import * as angular from "angular";
import "angular-utf8-base64";
import {ChatService} from "./chat.service";
import {ChatComponent} from "./chat.component";
import {FirebaseModule} from "../firebase/firebase.module";
import {NotificationsModule} from "../notifications/notifications.module";

export const ChatModule = angular
    .module("app.shared.chat", [
        "utf8-base64",
        "ui.router",
        FirebaseModule,
        NotificationsModule
    ])

    .service("chatService", ChatService)

    .component("chat", ChatComponent)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/chat/chat.module.ts